<template>
  <v-container>
    <h1>{{ get("header-1") }}</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <p>
              {{ get("p-1") }}
            </p>
          </v-col>
          <v-col cols="12" xl="6" lg="6" md="6" sm="6">
            <v-img :src="houseImage" class="image" left></v-img>
          </v-col>
        </v-row>
        <v-row>
          <div :class="theme + '-alt-background-1'">
            <div>
              <h2>
                {{ get("header-2") }}
              </h2>
              <p>
                {{ get("company") }} {{ get("p-2.1") }}
              </p>
              <ul>
                <li>
                  <p>{{ get("p-2.2")}}}</p>
                </li>
                <li>
                  <p>
                    {{ get("p-2.3")  }}
                  </p>
                </li>
                <li>
                  <p>{{ get("p-2.4") }}</p>
                </li>
                <li>
                  <p>
                    {{ get("p-2.5") }}
                  </p>
                </li>
                <li>
                  <p>
                    {{ get("p-2.6") }}
                  </p>
                </li>
              </ul>
              <p>
                {{ get("p-2.7") }}
              </p>
            </div>
          </div>
        </v-row>
        <v-row>
          <div
            :class="theme + '-alt-background-2'"
          >
            <div>
              <h2>{{ get("heading-3") }}</h2>
              <p>
                {{ get("company")}} {{ get("p-3.1") }}
              </p>
              <ul>
                <li>
                  <p>
                    {{ get("p-3.2") }}
                  </p>
                </li>
                <li>
                  <p>{{ get("p-3.3") }}</p>
                </li>
                <li>
                  <p>
                    {{ get("p-3.4") }}
                  </p>
                </li>
                <li>
                  <p>
                    {{ get("p-3.5") }}
                  </p>
                </li>
                <li>
                  <p>
                    {{ get("p-3.6") }}
                  </p>
                </li>
              </ul>
              <p>
                {{ get("p-3.7") }} {{ get("company") }} {{ get("-3.8") }}
              </p>
            </div>
          </div>
        </v-row>
        <v-row>
          <h2>
            {{ get("heading-4") }}
          </h2>
          <p>
            {{ get("p-4.1") }} {{ get("company") }} {{ get("p-4.2") }}
          </p>
        </v-row>
        <v-row>
          <h2>{{ get("heading-5") }}</h2>
          <p>
            {{ get("p-5.1") }} {{ get("company") }} {{ get("p-5.2") }} 
            <phonenumber phone="(719) 390-7663"></phonenumber> 
            {{ get("p-5.3") }}
          </p>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "@/components/controls/estimate-ctrl";
import localizationMixin from "@/mixins/localization-mixin";
import phonenumber from "@/components/controls/phone-number";

export default {
  name: "Roofing-Repair",

  components: {
    estimate,
    phonenumber
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
  
    created() {
    this.pageName = "roof-replacement";
  },

  data: () => ({
    houseImage: require("@/assets/house-5.jpeg"),
  }),

  mixins: [localizationMixin],
  methods: {

    getLocalization() {    
    }
  },

};
</script>

<style lang="scss" scoped>

</style>